import React from 'react';
import { Link } from 'react-router-dom';

const SignupSuccess: React.FC = () => {
    return (
        <>
            <div className="col-12 col-md-8 col-xl-6">
                <div className="h-100 py-4 px-md-3">
                    <div className="row h-100 align-items-center justify-content-center">
                        <div className="col-12 col-sm-8 col-md-11 col-xl-11 col-xxl-10 login-box">
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className="text-center mb-3 mb-lg-4">
                                        <h1 className="mb-1 text-theme-1">Congratulations🥳</h1>
                                        <p className="text-secondary">You come so far and ready!</p>
                                    </div>

                                    <div className="row gx-3 gx-lg-4 align-items-center p-2">
                                        <div className="col-6">
                                            <Link to="/auth/onboarding" className="btn btn-lg btn-link border border-theme-1 h-auto w-100">
                                                <i className="bi bi-shop fs-1 height-40 width-50 d-block my-3 mx-auto"></i>
                                                <p className="h5 mb-0">Individual</p>
                                                <p className="fs-12 mb-2">Managing alone</p>
                                                <i className="bi bi-arrow-right avatar avatar-40 rounded-circle mb-2"></i>
                                            </Link>
                                        </div>
                                        <div className="col-6">
                                            <Link to="/auth/onboarding" className="btn btn-lg btn-theme h-auto w-100">
                                                <i className="bi bi-buildings fs-1 height-40 width-50 d-block my-3 mx-auto"></i>
                                                <p className="h5 mb-0">Business</p>
                                                <p className="fs-12 mb-2">Multi-user access</p>
                                                <i className="bi bi-arrow-right avatar avatar-40 rounded-circle mb-2"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SignupSuccess;
